import React from 'react';
import { TaxBasedAmountPanel } from '../components/TaxBasedAmountPanel';

export const MontoImpuestosPage: React.FC = () => {
  return <TaxBasedAmountPanel />;
};
